<template>
  <el-container id="container">
    <el-header class="header">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" class="left-nav">
        <LeftNav/>
      </el-aside>
      <el-main class="main" id="main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import Top from '../components/Top/Top';
  import LeftNav from '../components/LeftNav/LeftNav';

  export default {
    name: 'home',
    components: {
      Top,
      LeftNav
    },
    mounted() {
      let orderHeight = document.body.clientHeight;
      document.getElementById('container').style.height = orderHeight + 'px';
      document.getElementById('main').style.height = (orderHeight - 60) + 'px';
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .header
    background: #f3f3f4;

  .left-nav
    background: #fff;

  .main
    background: #F2F6FC;
</style>
